import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { TicketsContent } from '@starjack/widgets/tickets';
import { Permission } from '@/models/user';

const Tickets: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Tickets | Starjack Backoffice</title>
            </Helmet>
            <TicketsContent />
        </>
    );
};

Tickets.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Tickets.isProtected = true;
Tickets.permissions = [Permission.SUPPORTER];

export default Tickets;
